import $ from 'jquery';
import 'jquery.cookie/jquery.cookie.js';
import 'lazysizes';
import * as vars from "./globals/variables";

/*
 * INTRO
 */


if (!$.cookie('bn-intro')) {
    $.cookie('bn-intro', 1, {path: '/'});
}

// delete cookie if user switches language
$('body').on('click', '.bn-lang-menu-static a', function () {
    $.removeCookie('bn-intro');
});

vars.$body.removeClass('no-font');



// WEBPACK FOOTER //
// ./source/js/intro.js